export enum PaymentModel {
  CUSTOMER_PAID = "customer_paid",
  MERCHANT_PAID = "merchant_paid",
}

/**
 * Derives the payment model from merchant-paid date ranges.
 * If the given date (default: now) falls within any active range, returns MERCHANT_PAID.
 * Ranges are start-inclusive, end-exclusive: [start, end).
 */
export function derivePaymentModel(
  merchantPaidEnabledDates:
    | { start: string | null; end?: string | null }[]
    | undefined
    | null,
  date: Date = new Date(),
): PaymentModel {
  if (!merchantPaidEnabledDates || merchantPaidEnabledDates.length === 0) {
    return PaymentModel.CUSTOMER_PAID;
  }
  const isInRange = merchantPaidEnabledDates.some(
    (range) =>
      range.start != null &&
      new Date(range.start) <= date &&
      (range.end == null || date < new Date(range.end)),
  );
  return isInRange ? PaymentModel.MERCHANT_PAID : PaymentModel.CUSTOMER_PAID;
}
